exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle-icon {\n  max-width: 25px;\n  max-height: 25px;\n  border: 1px solid #ccc;\n  border-radius: 100%;\n  padding: 10px;\n  text-transform: uppercase;\n  color: #ffffff;\n  margin: 2px;\n  font-weight: normal;\n  overflow: hidden;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -ms-flex-align: center;\n  align-items: center; }\n  @media only screen and (max-width: 425px) {\n    .circle-icon {\n      font-size: 10px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/treeTableWithSlider/circleIcon/CircleIcon.style.scss
// module id = 669
// module chunks = 0